import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './CaseStudy.scss';

const CaseStudy = ({ caseStudyUrl }) => {
    const [markdown, setMarkdown] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!caseStudyUrl) {
            setLoading(false);
            return;
        }

        fetch(caseStudyUrl)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to load case study');
                }
                return response.text();
            })
            .then(text => {
                setMarkdown(text);
                setLoading(false);
            })
            .catch(err => {
                setError(err.message);
                setLoading(false);
            });
    }, [caseStudyUrl]);

    if (!caseStudyUrl) return null;
    if (loading) return <div className="case-study-loading">Loading case study...</div>;
    if (error) return <div className="case-study-error">Error loading case study: {error}</div>;

    return (
        <div className="case-study">
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                skipHtml
                components={{
                    h1: ({ node, ...props }) => <span style={{ display: 'none' }} {...props} />, // Hide h1
                    h2: ({ node, ...props }) => <h2 className="" {...props} />,
                    h3: ({ node, ...props }) => <h3 className="case-study-feature" {...props} />,
                    pre: ({ node, ...props }) => <pre className="code-block-wrapper" {...props} />,
                    code: ({ node, inline, className, ...props }) =>
                        inline ?
                            <code className="inline-code" {...props} /> :
                            <code className={`code-block ${className || ''}`} {...props} />,
                    blockquote: ({ node, ...props }) => <blockquote className="talking-point" {...props} />,
                    table: ({ node, ...props }) => <table className="case-study-table" {...props} />
                }}
            >
                {markdown}
            </ReactMarkdown>
        </div>
    );
};

export default CaseStudy;